import { Tag, Emitter, Context } from '..'

export default class extends Tag {
  render (ctx: Context, _emitter: Emitter) {
    ctx.continueCalled = true
  }
}
